var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "dashboard-block" }, [
    _c(
      "form",
      [
        _c("h2", [_vm._v("Notifications")]),
        _vm._v(" "),
        _c("div", { staticClass: "row row-clear-md-4" }, [
          _c("div", { staticClass: "col-md-4" }, [
            _c(
              "div",
              {
                class: _vm.$hasErrorClass(
                  _vm.$v.stateBillboardPostLength,
                  "form-group"
                ),
              },
              [
                _c("label", { staticClass: "control-label" }, [
                  _vm._v("Billboard posting length"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "input-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.lazy",
                        value: _vm.$v.stateBillboardPostLength.$model,
                        expression: "$v.stateBillboardPostLength.$model",
                        modifiers: { lazy: true },
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { name: "billboard_post_length", type: "number" },
                    domProps: { value: _vm.$v.stateBillboardPostLength.$model },
                    on: {
                      change: function ($event) {
                        return _vm.$set(
                          _vm.$v.stateBillboardPostLength,
                          "$model",
                          $event.target.value
                        )
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "input-group-addon" }, [
                    _vm._v("days"),
                  ]),
                ]),
                _vm._v(" "),
                _c("vuelidate-help", {
                  attrs: {
                    label: "Billboard post length",
                    field: _vm.$v.stateBillboardPostLength,
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4" }, [
            _c(
              "div",
              {
                class: _vm.$hasErrorClass(
                  _vm.$v.stateDepositPaymentWarningAdmin,
                  "form-group"
                ),
              },
              [
                _c("label", { staticClass: "control-label" }, [
                  _vm._v("Deposit payment warning for admin"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "input-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.lazy",
                        value: _vm.$v.stateDepositPaymentWarningAdmin.$model,
                        expression: "$v.stateDepositPaymentWarningAdmin.$model",
                        modifiers: { lazy: true },
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      name: "deposit_payment_warning_admin",
                      type: "number",
                    },
                    domProps: {
                      value: _vm.$v.stateDepositPaymentWarningAdmin.$model,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$set(
                          _vm.$v.stateDepositPaymentWarningAdmin,
                          "$model",
                          $event.target.value
                        )
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "input-group-addon" }, [
                    _vm._v("days"),
                  ]),
                ]),
                _vm._v(" "),
                _c("vuelidate-help", {
                  attrs: {
                    label: "Deposit warning notification for admin",
                    field: _vm.$v.stateDepositPaymentWarningAdmin,
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4" }, [
            _c(
              "div",
              {
                class: _vm.$hasErrorClass(
                  _vm.$v.stateDepositPaymentWarningClient,
                  "form-group"
                ),
              },
              [
                _c("label", { staticClass: "control-label" }, [
                  _vm._v("Deposit payment warning for client"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "input-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.lazy",
                        value: _vm.$v.stateDepositPaymentWarningClient.$model,
                        expression:
                          "$v.stateDepositPaymentWarningClient.$model",
                        modifiers: { lazy: true },
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      name: "deposit_payment_warning_client",
                      type: "number",
                    },
                    domProps: {
                      value: _vm.$v.stateDepositPaymentWarningClient.$model,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$set(
                          _vm.$v.stateDepositPaymentWarningClient,
                          "$model",
                          $event.target.value
                        )
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "input-group-addon" }, [
                    _vm._v("days"),
                  ]),
                ]),
                _vm._v(" "),
                _c("vuelidate-help", {
                  attrs: {
                    label: "Deposit warning notification for client",
                    field: _vm.$v.stateDepositPaymentWarningClient,
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4" }, [
            _c(
              "div",
              {
                class: _vm.$hasErrorClass(
                  _vm.$v.stateFinalPaymentWarningAdmin,
                  "form-group"
                ),
              },
              [
                _c("label", { staticClass: "control-label" }, [
                  _vm._v("Final payment warning for admin"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "input-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.lazy",
                        value: _vm.$v.stateFinalPaymentWarningAdmin.$model,
                        expression: "$v.stateFinalPaymentWarningAdmin.$model",
                        modifiers: { lazy: true },
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      name: "final_payment_warning_admin",
                      type: "number",
                    },
                    domProps: {
                      value: _vm.$v.stateFinalPaymentWarningAdmin.$model,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$set(
                          _vm.$v.stateFinalPaymentWarningAdmin,
                          "$model",
                          $event.target.value
                        )
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "input-group-addon" }, [
                    _vm._v("days"),
                  ]),
                ]),
                _vm._v(" "),
                _c("vuelidate-help", {
                  attrs: {
                    label: "Final payment warning for client",
                    field: _vm.$v.stateFinalPaymentWarningAdmin,
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4" }, [
            _c(
              "div",
              {
                class: _vm.$hasErrorClass(
                  _vm.$v.stateFinalPaymentWarningClient,
                  "form-group"
                ),
              },
              [
                _c("label", { staticClass: "control-label" }, [
                  _vm._v("Final payment warning for client"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "input-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.lazy",
                        value: _vm.$v.stateFinalPaymentWarningClient.$model,
                        expression: "$v.stateFinalPaymentWarningClient.$model",
                        modifiers: { lazy: true },
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      name: "final_payment_warning_client",
                      type: "number",
                    },
                    domProps: {
                      value: _vm.$v.stateFinalPaymentWarningClient.$model,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$set(
                          _vm.$v.stateFinalPaymentWarningClient,
                          "$model",
                          $event.target.value
                        )
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "input-group-addon" }, [
                    _vm._v("days"),
                  ]),
                ]),
                _vm._v(" "),
                _c("vuelidate-help", {
                  attrs: {
                    label: "Final payment warning for client",
                    field: _vm.$v.stateFinalPaymentWarningClient,
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4" }, [
            _c(
              "div",
              {
                class: _vm.$hasErrorClass(
                  _vm.$v.stateInitialTalentReminder,
                  "form-group"
                ),
              },
              [
                _c("label", { staticClass: "control-label" }, [
                  _vm._v(
                    "Initial reminder for " + _vm._s(_vm.$starLabelPlural)
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "input-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.lazy",
                        value: _vm.$v.stateInitialTalentReminder.$model,
                        expression: "$v.stateInitialTalentReminder.$model",
                        modifiers: { lazy: true },
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { name: "initial_talent_reminder", type: "number" },
                    domProps: {
                      value: _vm.$v.stateInitialTalentReminder.$model,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$set(
                          _vm.$v.stateInitialTalentReminder,
                          "$model",
                          $event.target.value
                        )
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "input-group-addon" }, [
                    _vm._v("days"),
                  ]),
                ]),
                _vm._v(" "),
                _c("vuelidate-help", {
                  attrs: {
                    label: "Initial talent reminder",
                    field: _vm.$v.stateInitialTalentReminder,
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4" }, [
            _c(
              "div",
              {
                class: _vm.$hasErrorClass(
                  _vm.$v.stateSecondTalentReminder,
                  "form-group"
                ),
              },
              [
                _c("label", { staticClass: "control-label" }, [
                  _vm._v(
                    "Second reminder for " +
                      _vm._s(_vm.$starLabelPlural) +
                      " with response"
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "input-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.lazy",
                        value: _vm.$v.stateSecondTalentReminder.$model,
                        expression: "$v.stateSecondTalentReminder.$model",
                        modifiers: { lazy: true },
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { name: "second_talent_reminder", type: "number" },
                    domProps: {
                      value: _vm.$v.stateSecondTalentReminder.$model,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$set(
                          _vm.$v.stateSecondTalentReminder,
                          "$model",
                          $event.target.value
                        )
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "input-group-addon" }, [
                    _vm._v("days"),
                  ]),
                ]),
                _vm._v(" "),
                _c("vuelidate-help", {
                  attrs: {
                    label: "Second talent reminder",
                    field: _vm.$v.stateInitialTalentReminder,
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4" }, [
            _c(
              "div",
              {
                class: _vm.$hasErrorClass(
                  _vm.$v.stateFinalTalentReminder,
                  "form-group"
                ),
              },
              [
                _c("label", { staticClass: "control-label" }, [
                  _vm._v("Final reminder for " + _vm._s(_vm.$starLabelPlural)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "input-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.lazy",
                        value: _vm.$v.stateFinalTalentReminder.$model,
                        expression: "$v.stateFinalTalentReminder.$model",
                        modifiers: { lazy: true },
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { name: "final_talent_reminder", type: "number" },
                    domProps: { value: _vm.$v.stateFinalTalentReminder.$model },
                    on: {
                      change: function ($event) {
                        return _vm.$set(
                          _vm.$v.stateFinalTalentReminder,
                          "$model",
                          $event.target.value
                        )
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "input-group-addon" }, [
                    _vm._v("hours"),
                  ]),
                ]),
                _vm._v(" "),
                _c("vuelidate-help", {
                  attrs: {
                    label: "Final talent reminder",
                    field: _vm.$v.stateSecondTalentReminder,
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "ladda-button",
          {
            staticClass: "btn btn-success",
            attrs: { click: _vm.handleSaveNotificationSettingsCallback },
          },
          [
            _c("i", { staticClass: "fa fa-check" }),
            _vm._v(" Save Changes\n    "),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }